module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bgView"
  }, [_c('mu-paper', {
    staticClass: "insetGraph"
  }, [_c('mu-tabs', {
    model: {
      value: (_vm.selectedTab),
      callback: function($$v) {
        _vm.selectedTab = $$v
      },
      expression: "selectedTab"
    }
  }, [_c('mu-tab', {
    attrs: {
      "value": "bloodGlucose"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('message.cardBloodGlucose')) + "\n      ")]), _vm._v(" "), _c('mu-tab', {
    attrs: {
      "value": "hba1c"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goTo('HbA1cProgress')
      }
    }
  }, [_vm._v("\n       " + _vm._s(_vm.$t('message.cardHbA1c')) + "\n      ")])], 1), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('bg-line-graph', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "50",
      "width": "100"
    }
  }, [_c('blood-glucose-range', {
    staticStyle: {
      "margin-top": "24px"
    }
  }), _vm._v(" "), (_vm.$store.state.user.settings) ? _c('blood-glucose-input', {
    staticClass: "card-spacing bottom",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "hba1c": _vm.$store.state.user.settings.hba1c,
      "bloodGlucose": _vm.$store.state.user.settings.blood_glucose
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings) ? _c('hba1c-input', {
    staticClass: "bottom",
    attrs: {
      "hba1c": _vm.$store.state.user.settings.hba1c
    }
  }) : _vm._e(), _vm._v(" "), _c('blood-glucose-targets', {
    attrs: {
      "hba1c": _vm.$store.state.user.settings.hba1c,
      "bloodGlucose": _vm.$store.state.user.settings.blood_glucose
    }
  }), _vm._v(" "), _c('tracking-exporter', {
    attrs: {
      "type": "blood-glucose"
    }
  }), _vm._v(" "), _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-card-text', [_c('p', {
    staticClass: "tracking-subtext",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.trackingHelpText'))
    }
  })]), _vm._v(" "), (_vm.readingTags.length > 0) ? _c('mu-timeline', _vm._l((_vm.groupFilter()), function(group, groupKey) {
    return _c('div', {
      key: 'group-key-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'tracking-timeline-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        attrs: {
          "iconColor": _vm.determineColor(item),
          "iconLine": "8",
          "iconType": "solid"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.showItemControls(item)
          }
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e()]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading",
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [(item.userDevice && item.userDevice.userDeviceId !== 0) ? _c('span', [_c('img', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip.left",
          value: (_vm.$t('message.cardFromDevice') + item.userDevice.nickname),
          expression: "$t('message.cardFromDevice') +   item.userDevice.nickname",
          modifiers: {
            "left": true
          }
        }],
        staticStyle: {
          "position": "relative",
          "top": "6px"
        },
        attrs: {
          "width": "22",
          "src": item.userDevice.device.iconBlue
        }
      })]) : _vm._e(), _vm._v(" "), _c('span', {
        domProps: {
          "textContent": _vm._s(_vm.data.preference === 'mmoll' ? '' + item.blood_glucose_mmoll + ' mmol/L' : item.blood_glucose_mgdl + ' mg/dL')
        }
      })]) : _vm._e()])], 1), _vm._v(" "), (item.tags.length > 0 && !item.isEditMode) ? _c('div', {
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, _vm._l((item.tags), function(tag, tagIndex) {
        return (tag.tag_id !== null) ? _c('span', {
          key: tagIndex
        }, [(tagIndex === 0 && item.tags.length === 1) ? _c('span', [(tagIndex <= 1) ? _c('span', {
          domProps: {
            "textContent": _vm._s(_vm.$t(_vm.localizeTag(tag.tag)))
          }
        }) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.tags.length > 1) ? _c('span', [(tagIndex <= 1) ? _c('span', {
          domProps: {
            "textContent": _vm._s(_vm.$t(_vm.localizeTag(tag.tag)) + (tagIndex === 1 && !item.showAllTags ? '' : ', '))
          }
        }) : _vm._e(), _vm._v(" "), (tagIndex > 1 && item.showAllTags) ? _c('span', {
          domProps: {
            "textContent": _vm._s(_vm.$t(_vm.localizeTag(tag.tag)) + (tagIndex === item.tags.length - 1 ? '' : ', '))
          }
        }) : _vm._e(), _vm._v(" "), (tagIndex == item.tags.length - 1 && item.tags.length > 2) ? _c('a', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!item.showAllTags),
            expression: "!item.showAllTags"
          }],
          on: {
            "click": function($event) {
              return _vm.showAllTags(item)
            }
          }
        }, [_c('span', [_vm._v("+")]), _c('span', {
          domProps: {
            "textContent": _vm._s(item.tags.length - 2 + ' ' + String(_vm.$t('message.moreText')).toLowerCase())
          }
        })]) : _vm._e(), _vm._v(" "), (tagIndex == item.tags.length - 1 && item.tags.length > 2) ? _c('a', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (item.showAllTags),
            expression: "item.showAllTags"
          }],
          on: {
            "click": function($event) {
              return _vm.showAllTags(item)
            }
          }
        }, [_c('span', {
          domProps: {
            "textContent": _vm._s(String(_vm.$t('message.hideText')).toLowerCase())
          }
        })]) : _vm._e()]) : _vm._e()]) : _vm._e()
      }), 0) : _vm._e(), _vm._v(" "), (!item.isEditMode && item.tags.length === 0) ? _c('div', {
        staticClass: "no_tags"
      }, [_vm._v("\n                 " + _vm._s(_vm.$t('message.labelNoTags')) + "\n                ")]) : _vm._e(), _vm._v(" "), (item.isControlsVisible && !item.isEditMode) ? _c('div', {
        attrs: {
          "align": "right"
        }
      }, [_c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.editText'),
          "icon": "edit"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.editReading(item)
          }
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.deleteText'),
          "icon": "delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteReading(item)
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.isEditMode) ? _c('div', [_c('bg-edit', {
        attrs: {
          "tags": _vm.readingTags,
          "preference": _vm.data.preference,
          "item": item
        },
        on: {
          "updateReading": _vm.updateReading,
          "closeEditPanel": function($event) {
            return _vm.closeEditMode(item)
          }
        }
      })], 1) : _vm._e()], 1)], 1)
    })], 2)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.loadingText')))])], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73cd8958","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tracking/BloodGlucose.vue
// module id = 3780
// module chunks = 1